import React from "react";
import SmartIcon from "./SmartIcon.tsx";
import {GenericMenuItem} from "../models/interfaces/genericMenuItem.ts";

interface ModalSideMenuProps {
  items: GenericMenuItem[];
  activeItem: GenericMenuItem;
  setActiveItem: (item: GenericMenuItem) => void;
}


const ModalSideMenu: React.FC<ModalSideMenuProps> = ({items, activeItem, setActiveItem}: ModalSideMenuProps) => {
  const handleClick: (activeItem: GenericMenuItem) => void = (activeItem: GenericMenuItem) => {
    setActiveItem(activeItem);
  };

  return items.map((item: GenericMenuItem, index: number) => (
    <div className="mb-1" key={index}>
      {item.id === "delete-account" && (
        <div className="h-0.25 my-3 bg-n-300 dark:bg-n-600"></div>
      )}
      <button
        className={`group flex items-center w-full px-3.5 py-1.5 rounded-full border-2 border-transparent base2 font-semibold transition-colors hover:bg-n-200 tap-highlight-color dark:hover:bg-n-600 dark:hover:text-n-100 ${
          item.id === "delete-account"
            ? `!text-accent-1 ${
              activeItem === item &&
              "!border-accent-1 !bg-n-100 dark:!bg-transparent"
            }`
            : `text-n-400 ${
              activeItem === item &&
              "!border-brandPurple-500 text-n-700 !bg-n-100 dark:!bg-transparent dark:text-n-100"
            }`
        }`}
        onClick={() => handleClick(item)}
      >
        <SmartIcon
          className={`w-4 h-4 mr-3 transition-colors ${
            item.id === "delete-account"
              ? `!fill-accent-1`
              : `fill-n-400 ${
                activeItem === item &&
                "fill-n-700 dark:fill-n-100 dark:group-hover:fill-n-100"
              }`
          }`}
          name={item.icon}
        />
        {item.title}
      </button>
    </div>
  ));
};

export default ModalSideMenu;
